import { convertDurationToSeconds } from '../utils/cron-frequencies';

export const CRON_FREQUENCIES = [
  '1 minute',
  '5 minutes',
  '15 minutes',
  '30 minutes',
  '1 hour',
  '3 hours',
  '6 hours',
  '12 hours',
  '1 day',
] as const; // Use const assertion to infer exact values

export interface CronFrequencyOption {
  value: number;
  label: CronFrequencyLabel;
}

export type CronFrequencyLabel = keyof typeof CronFrequencyLabels;

export const CronFrequencyLabels = Object.fromEntries(
  CRON_FREQUENCIES.map(value => [value, value]),
) as {
  [K in (typeof CRON_FREQUENCIES)[number]]: K;
};

export const CronFrequencyEntries: [CronFrequencyLabel, number][] =
  Object.entries(CronFrequencyLabels).map(([key, _value]) => [
    _value,
    convertDurationToSeconds(key),
  ]);
export const CronFrequencyValueSecondsMap: Record<CronFrequencyLabel, number> =
  Object.assign(
    {},
    ...CronFrequencyEntries.map(([key, value]) => ({ [key]: value })),
  );

// Create the reverse map
export const SecondsToCronFrequencyLabelMap: Record<
  number,
  CronFrequencyLabel
> = Object.assign(
  {},
  ...CronFrequencyEntries.map(([key, value]) => ({ [value]: key })),
);
